import { BaseModel } from "@/modules/core/classes/BaseModel";

const uuidv4 = require("uuid/v4");

export class Filter extends BaseModel {
  constructor(params) {
      super(params);
      if (!this.id) this.id = uuidv4();
      if (!this.type) this.type = "search";
  }

  $fields() {
    return ["name", "key", "type", "input", "options", "optionLabel", "optionId"];
  }
}